<template>
  <div>
    <div class="header">
      <div class="l">
        <p>趣豆：{{ score }}</p>
        <p>有效期：{{ recentlyPeriod }}</p>
      </div>
      <div class="r">
        <mt-button size="large" type="primary" @click="changeRouter('transfer')" v-show="use"
          >转出</mt-button
        >
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  props: ["use"],
  data() {
    return {
      score: "",
      recentlyPeriod: "",
    };
  },
  mounted() {
    this.getMyScore();
  },
  methods: {
    //1.myAllScore 我所有积分
    getMyScore() {
    
      this.post(this.apis.myAllScore, {
        memberId: this.userInfo.memberId,
      })
        .then((response) => {
          if (response.data.retCode == "SUCCESS") {
            this.score = response.data.score;
            this.recentlyPeriod = response.data.recentlyPeriod;
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
   computed: {
    ...mapState(["userInfo"]),
  },
};
</script>

<style lang="less" scoped>
.header {
  background-color: #ffaa5e;
  padding: 20px 48px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .l {
    p {
      font-family: PingFang-SC-Regular;
      color: #fff;
      font-size: 24px;
    }
    p:first-child {
      font-size: 28px;
      font-weight: bold;
      padding-bottom: 10px;
    }
  }
  .r {
    .mint-button--large {
      width: 136px;
      height: 47px;
      font-size: 26px;
    }
  }
}
</style>
